export default __webpack_public_path__ + "36a03682a8ce22727294d172d240ca14.png";